import React from 'react';

const RecordVoice = () => {
    return (
        <svg width={21} height={21} viewBox="0 0 21 21">
            <defs>
                <style>{'.prefix__b{fill:#8f99dc}'}</style>
            </defs>
            <g transform="translate(-182 -688)">
                <circle
                    cx={10.5}
                    cy={10.5}
                    r={10.5}
                    transform="translate(182 688)"
                    fill="#fff"
                />
                <path
                    className="prefix__b"
                    d="M196.519 698.212a.441.441 0 10-.881 0 3.114 3.114 0 01-6.228 0 .441.441 0 00-.881 0 4 4 0 003.555 3.981v1.17h-1.6a.441.441 0 100 .881h4.084a.441.441 0 100-.881h-1.6v-1.175a4 4 0 003.551-3.976z"
                />
                <path
                    className="prefix__b"
                    d="M192.523 691.763a2.457 2.457 0 00-2.449 2.453v3.981a2.453 2.453 0 104.9.015v-4a2.457 2.457 0 00-2.451-2.449z"
                />
            </g>
        </svg>
    );
};

export default RecordVoice;
